





















import { Component, Vue, Ref } from 'vue-property-decorator'
import { checkCaptcha, sendPasswordResetLink } from '@/request/apis/UserRequest'
import { ElForm } from 'element-ui/types/form'
import CaptchaInput from '@/components/common/CaptchaInput.vue'

@Component({
  components: {
    CaptchaInput
  }
})
export default class RecoverPasswordForm extends Vue {
  @Ref('form') readonly submitForm!: ElForm
  @Ref('captchaInput') readonly captchaInput!: CaptchaInput

  private form = {
    email: '',
    password: '',
    captcha: ''
  }
  private loading: boolean = false

  private get rules () {
    const checkCaptcha = (rule: any, value: string, callback: Function) => {
      if (!value) {
        return callback(new Error(<string>this.$t('loginRegister.captchaEmptyError')))
      }
      if (!this.captchaInput.captchaIsCorrect) {
        return callback(new Error(<string>this.$t('loginRegister.captchaNotCorrect')))
      }
      callback()
    }
    return {
      email: [
        { required: true, message: this.$t('loginRegister.mailEmptyError'), trigger: 'blur' }
      ],
      captcha: [
        { validator: checkCaptcha, trigger: 'blur' }
      ]
    }
  }

  /**
   * 检查验证码是否正确
   * @param value 输入的验证码
   */
  private checkCaptcha (value: string) {
    return checkCaptcha(null, value, { showSuccessMsg: false, showErrorMsg: false }).start().then(() => {
      return true
    }).catch(() => {
      return false
    })
  }

  /**
   * 表单提交
   */
  private confirmHandler () {
    this.submitForm.validate(async (valid) => {
      if (valid) {
        this.loading = true
        try {
          await sendPasswordResetLink(null, this.form).start()
          this.$emit('sendResetLinkSuccess', new CustomEvent('sendResetLinkSuccess'))
        } catch (e) {
          this.captchaInput.updateCaptchaImg()
          console.log(e)
        }
        this.loading = false
      } else {
        return false
      }
    })
  }
}
